type Options = {
  payload: string;
  className?: string;
};

export default function Title(props: Options) {
  return (
    <div
      className={`text-heading-3-semibold text-neutral-950 max-sm:text-heading-6-semibold ${props.className}`}
    >
      {props.payload}
    </div>
  );
}
